/* eslint eqeqeq: 0 */
import { Record } from "immutable";
import moment from "moment";

const TeaserStatItemRecord = new Record({
  date: undefined,

  shows: 0,
  clicks: 0,
  spent: 0,
  ctr: 0,

  s_shows: 0,
  s_top_shows: 0,
  s_inf_shows: 0,
  s_clicks: 0,
  s_spent: 0,
  a_ctr: 0
});

export default class TeaserStatItem extends TeaserStatItemRecord {
  isWeekEnd() {
    const day = moment(this.date).day();

    if (day == 0 || day == 6) {
      return true;
    }

    return false;
  }
}
